export const getAppointmentTypes = (state) => state.types